/**
 * Shared helper for normalizing the camera capture ratio from settings.
 *
 * Rules:
 *   - `'auto'`                     → `undefined` (no crop; full sensor frame)
 *   - finite positive number        → that ratio (width/height)
 *   - `undefined` / `null` / non-finite / ≤0 → `undefined` (same as `'auto'` — no L2 crop)
 *
 * All capture pages (Classic, FrameBasedCapture, Retake, customRoutes) should call this
 * instead of duplicating the same inline logic with slightly different fallback values.
 */
export function getNormalizedCaptureRatio(captureRatio: number | 'auto' | undefined): number | undefined {
  if (captureRatio === 'auto') return undefined
  if (typeof captureRatio === 'number' && Number.isFinite(captureRatio) && captureRatio > 0) {
    return captureRatio
  }
  return undefined
}
